import { Tooltip } from '@material-ui/core';
import React from 'react'
import { Link } from 'react-router-dom';

const TermsAdd = () => {

  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/terms/add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Terms & Condition
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
                      <h1>Content Goes Here</h1>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}
export default TermsAdd